import React from 'react'
import styled from '@emotion/styled'

import BannerImageRemserv from './bannerImageRemserv.jpg'
import BannerImageRemServ2 from './banner.jpg'
import BannerProposalRemServ from './proposal_banner.png'
import RemLeaseLogo from './rem_lease.png'
import Loader from './loader.gif'
import UserTestimonial1 from './icon-testimonial-user-1.jpg'
import UserTestimonial2 from './icon-testimonial-user-2.jpg'
import UserTestimonial3 from './icon-testimonial-user-default.png'

const imagesMap = {
  BannerImageRemserv,
  BannerImageRemServ2,
  BannerProposalRemServ,
  Loader,
  RemLeaseLogo,
  UserTestimonial1,
  UserTestimonial2,
  UserTestimonial3,
}

export const Image = (props) => {
  const imageName = props.imageName
  const height = props.height
  const width = props.width

  const CustomImage = styled.img`
    label: CustomImage;
    height: ${height ? height + 'px' : 'auto'};
    width: ${width ? width + 'px' : 'auto'};
  `

  return <CustomImage {...props} src={imagesMap[imageName]} />
}
